import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, Fragment as _Fragment, createBlock as _createBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, renderList as _renderList, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/zoom.svg'
import _imports_1 from '@/assets/icons/house.svg'
import _imports_2 from '@/assets/icons/image-file-icon.svg'
import _imports_3 from '@/assets/icons/user.svg'


const _withScopeId = n => (_pushScopeId("data-v-2faf060d"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "main_project_details"
}
const _hoisted_2 = {
  key: 0,
  class: "info-message"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " The project is ready to start once the contractor confirms this job. ", -1))
const _hoisted_4 = { class: "left_block" }
const _hoisted_5 = { class: "top_links_main mobile__wrapper" }
const _hoisted_6 = { class: "back_results" }
const _hoisted_7 = {
  key: 1,
  class: "dispute_project tw-mb-4 tw-w-full tw-p-4 tw-box-border tw-rounded-lg tw-border-[#3B67E9] tw-bg-[rgba(59,103,233,0.08)] tw-border-[1px] tw-border-solid tw-flex tw-gap-16 tw-items-center"
}
const _hoisted_8 = { class: "tw-w-full tw-flex tw-flex-col tw-items-start tw-gap-4" }
const _hoisted_9 = { class: "tw-flex tw-pb-4 tw-border-b-dashed-custom tw-box-border tw-w-full" }
const _hoisted_10 = { class: "tw-w-full tw-flex tw-flex-col tw-items-start tw-gap-3" }
const _hoisted_11 = { class: "tw-w-full tw-flex tw-items-center tw-gap-2" }
const _hoisted_12 = { class: "tw-flex tw-items-center tw-w-auto tw-gap-2 tw-ml-5" }
const _hoisted_13 = { class: "tw-flex tw-flex-col tw-items-end tw-justify-between tw-gap-4" }
const _hoisted_14 = { class: "tw-bg-white tw-rounded-[12px] tw-flex tw-items-center tw-justify-center tw-p-4 tw-box-border" }
const _hoisted_15 = { class: "left_block" }
const _hoisted_16 = { class: "top_links_main mobile__wrapper" }
const _hoisted_17 = { class: "back_results" }
const _hoisted_18 = {
  key: 0,
  class: "proj_components list_block"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Team Members", -1))
const _hoisted_20 = { class: "list_block__item !tw-pb-[10px]" }
const _hoisted_21 = { class: "status__buttons" }
const _hoisted_22 = {
  key: 0,
  class: "save__project__button"
}
const _hoisted_23 = {
  key: 0,
  class: "list_block__item__wrapper"
}
const _hoisted_24 = { class: "proj_components list_block project_overview" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Project Overview", -1))
const _hoisted_26 = { class: "list_block__item" }
const _hoisted_27 = { class: "list_block__item__wrapper" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "list_block__item__wrapper__left" }, "Job Type", -1))
const _hoisted_29 = { class: "list_block__item__wrapper__right" }
const _hoisted_30 = {
  key: 0,
  class: "list_block__item__wrapper"
}
const _hoisted_31 = {
  key: 0,
  class: "list_block__item__wrapper__left"
}
const _hoisted_32 = { class: "list_block__item__wrapper__right" }
const _hoisted_33 = {
  key: 1,
  class: "list_block__item__wrapper"
}
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "list_block__item__wrapper__left" }, "Site Visit", -1))
const _hoisted_35 = { class: "list_block__item__wrapper__right" }
const _hoisted_36 = { class: "overview__detail" }
const _hoisted_37 = { class: "overview__detail__icon" }
const _hoisted_38 = ["src"]
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "custom__border" }, null, -1))
const _hoisted_40 = ["onClick"]
const _hoisted_41 = { class: "overview__detail__icon" }
const _hoisted_42 = ["src"]
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "custom__border" }, null, -1))
const _hoisted_44 = ["onClick"]
const _hoisted_45 = { class: "right_block" }
const _hoisted_46 = { class: "top_links_main desktop__wrapper" }
const _hoisted_47 = { class: "back_results" }
const _hoisted_48 = { class: "tw-w-full tw-flex tw-flex-col tw-gap-2 tw-items-start" }
const _hoisted_49 = ["innerHTML"]
const _hoisted_50 = { class: "project_info__wrapper" }
const _hoisted_51 = { class: "card_content" }
const _hoisted_52 = { class: "card_content__header" }
const _hoisted_53 = { class: "card_content__title" }
const _hoisted_54 = { class: "card_content__title_info" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "pointer_events_none" }, "Project ID:", -1))
const _hoisted_56 = { class: "pointer_events_none" }
const _hoisted_57 = { class: "card_content__footer" }
const _hoisted_58 = ["innerHTML"]
const _hoisted_59 = { class: "title" }
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "Project Title", -1))
const _hoisted_61 = { class: "description" }
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "Project Notes", -1))
const _hoisted_63 = { class: "custom_editor" }
const _hoisted_64 = { class: "edit__buttons" }
const _hoisted_65 = { class: "specialism__wrapper !tw-px-0 !tw-p-0 tw-overflow-hidden" }
const _hoisted_66 = { class: "tw-w-full tw-flex tw-items-center tw-justify-between tw-gap-4" }
const _hoisted_67 = { class: "tw-ml-3 tw-min-w-[36px] tw-w-[36px] tw-h-[36px] tw-flex tw-items-center tw-justify-center tw-rounded-full tw-border-[1.3px] tw-border-solid tw-border-[#DFDFDF] tw-bg-[#F8FBFD] tw-cursor-pointer" }
const _hoisted_68 = { class: "specialism__wrapper__content tw-border-t-dashed-custom" }
const _hoisted_69 = { key: 0 }
const _hoisted_70 = { class: "specialism-card-list" }
const _hoisted_71 = { class: "specialism-card-list__item-author" }
const _hoisted_72 = { class: "speicalism__icon" }
const _hoisted_73 = ["src"]
const _hoisted_74 = ["src"]
const _hoisted_75 = { class: "specialism-card-list__item-author-content" }
const _hoisted_76 = { class: "category_icon" }
const _hoisted_77 = ["src"]
const _hoisted_78 = { class: "category_text" }
const _hoisted_79 = {
  key: 0,
  class: "edit-mode-button !tw-py-4"
}
const _hoisted_80 = { class: "edit__buttons" }
const _hoisted_81 = { class: "properties_wrapper" }
const _hoisted_82 = { class: "header" }
const _hoisted_83 = { class: "title" }
const _hoisted_84 = { class: "count__property pointer_events_none" }
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " Open Map View ", -1))
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_87 = { class: "properties_wrapper__content" }
const _hoisted_88 = { class: "properties_wrapper__info__left" }
const _hoisted_89 = ["id"]
const _hoisted_90 = { class: "pointer_events_none" }
const _hoisted_91 = { class: "pointer_events_none" }
const _hoisted_92 = { class: "property__type__wrapper" }
const _hoisted_93 = ["id"]
const _hoisted_94 = ["id"]
const _hoisted_95 = {
  key: 0,
  class: "edit-mode-button"
}
const _hoisted_96 = { class: "edit__buttons" }
const _hoisted_97 = { class: "title" }
const _hoisted_98 = { key: 0 }
const _hoisted_99 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_100 = ["id"]
const _hoisted_101 = {
  key: 0,
  class: "group__cards"
}
const _hoisted_102 = { class: "group__card__text" }
const _hoisted_103 = ["id"]
const _hoisted_104 = ["id"]
const _hoisted_105 = { class: "doc__main__list" }
const _hoisted_106 = ["onClick"]
const _hoisted_107 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_2 }, null, -1))
const _hoisted_108 = ["onClick"]
const _hoisted_109 = {
  key: 0,
  class: "property__images"
}
const _hoisted_110 = ["src", "onClick"]
const _hoisted_111 = {
  key: 1,
  class: "edit-mode-button"
}
const _hoisted_112 = { class: "edit__buttons" }
const _hoisted_113 = {
  key: 1,
  class: "tw-flex tw-flex-col tw-justify-center tw-items-center tw-h-full tw-w-full tw-mt-[500px]"
}
const _hoisted_114 = {
  key: 1,
  class: "tooltip_wrapper",
  ref: "clickOutside"
}
const _hoisted_115 = { class: "custom__modal__heading" }
const _hoisted_116 = { class: "count__property" }
const _hoisted_117 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " This job is required across multiple properties, please select any you would like to combine into this estimate. ", -1))
const _hoisted_118 = { class: "tw-text-red-600" }
const _hoisted_119 = { class: "modal___content" }
const _hoisted_120 = { class: "property__cards" }
const _hoisted_121 = { class: "courses__card__list" }
const _hoisted_122 = { class: "courses__card__img" }
const _hoisted_123 = ["src"]
const _hoisted_124 = { class: "courses__card__prefix" }
const _hoisted_125 = { class: "left__prefix" }
const _hoisted_126 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: ""
}, null, -1))
const _hoisted_127 = { class: "right__prefix" }
const _hoisted_128 = { class: "courses__card__text" }
const _hoisted_129 = { class: "courses__card__title" }
const _hoisted_130 = { class: "load__wrapper" }
const _hoisted_131 = { class: "footer__button" }
const _hoisted_132 = { class: "modal__content md:!tw-gap-[.7rem] md:!tw-p-[10px] rmd:!tw-pb-4 rmd:!tw-items-end" }
const _hoisted_133 = { class: "left_upload_img" }
const _hoisted_134 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Upload images and filesss.", -1))
const _hoisted_135 = { class: "upload__area md:!tw-mt-[.5rem]" }
const _hoisted_136 = { class: "uploade-wrapper md:!tw-h-[100px]" }
const _hoisted_137 = {
  key: 0,
  class: "error_msg"
}
const _hoisted_138 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "upload__text" }, [
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "Drag and drop documents, or"),
    /*#__PURE__*/_createElementVNode("span", null, "Browse")
  ]),
  /*#__PURE__*/_createElementVNode("p", { class: "" }, " Attachments such as images, design ideas and documents help better understand the project and provide increasingly accurate estimates. ")
], -1))
const _hoisted_139 = { class: "footer-buttons" }
const _hoisted_140 = {
  key: 1,
  class: "tw-flex tw-flex-col tw-justify-center tw-items-center tw-h-full tw-w-full tw-mt-[500px]"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CongratsIcon = _resolveComponent("CongratsIcon")!
  const _component_Text = _resolveComponent("Text")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_InfoIcon = _resolveComponent("InfoIcon")!
  const _component_Button = _resolveComponent("Button")!
  const _component_EmergencyChip = _resolveComponent("EmergencyChip")!
  const _component_StandardChip = _resolveComponent("StandardChip")!
  const _component_RoutineChip = _resolveComponent("RoutineChip")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_expand_transition = _resolveComponent("v-expand-transition")!
  const _component_VideoConsultationChip = _resolveComponent("VideoConsultationChip")!
  const _component_AlertCard = _resolveComponent("AlertCard")!
  const _component_CommercialChip = _resolveComponent("CommercialChip")!
  const _component_ResidentialChip = _resolveComponent("ResidentialChip")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_quill_editor = _resolveComponent("quill-editor")!
  const _component_BlueCircularPencilIcon = _resolveComponent("BlueCircularPencilIcon")!
  const _component_v_expansion_panel_title = _resolveComponent("v-expansion-panel-title")!
  const _component_v_expansion_panel_text = _resolveComponent("v-expansion-panel-text")!
  const _component_v_expansion_panel = _resolveComponent("v-expansion-panel")!
  const _component_v_expansion_panels = _resolveComponent("v-expansion-panels")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_Loader = _resolveComponent("Loader")!
  const _component_ToolTipComment = _resolveComponent("ToolTipComment")!
  const _component_commonDialog = _resolveComponent("commonDialog")!
  const _component_v_file_input = _resolveComponent("v-file-input")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_ProjectAttachmentListComponent = _resolveComponent("ProjectAttachmentListComponent")!
  const _component_AddCommentComponent = _resolveComponent("AddCommentComponent")!
  const _component_InviteTeamMember = _resolveComponent("InviteTeamMember")!
  const _component_SpecialismMultiSelectModel = _resolveComponent("SpecialismMultiSelectModel")!
  const _component_v_carousel_item = _resolveComponent("v-carousel-item")!
  const _component_v_carousel = _resolveComponent("v-carousel")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_ChatCommentsComponent = _resolveComponent("ChatCommentsComponent")!
  const _component_ProjectRateModal = _resolveComponent("ProjectRateModal")!
  const _component_SiteVisitModel = _resolveComponent("SiteVisitModel")!
  const _component_ConfirmDeleteProjectModal = _resolveComponent("ConfirmDeleteProjectModal")!
  const _component_SuccessSendingReviewModal = _resolveComponent("SuccessSendingReviewModal")!
  const _component_PropertyWithMapModal = _resolveComponent("PropertyWithMapModal")!
  const _component_DSPModal = _resolveComponent("DSPModal")!
  const _component_DSPInformationModal = _resolveComponent("DSPInformationModal")!
  const _component_DSPOverviewModal = _resolveComponent("DSPOverviewModal")!
  const _component_DSPProjectDetailModal = _resolveComponent("DSPProjectDetailModal")!
  const _component_DisputeReasonModal = _resolveComponent("DisputeReasonModal")!
  const _component_DSPEvidenceGuidanceModal = _resolveComponent("DSPEvidenceGuidanceModal")!
  const _component_DSPRequestExtensionModal = _resolveComponent("DSPRequestExtensionModal")!
  const _component_ViewEvidenceModal = _resolveComponent("ViewEvidenceModal")!
  const _component_PostProjectLoadingModal = _resolveComponent("PostProjectLoadingModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!$setup.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", {
            class: _normalizeClass(["success-floater fixed tw-rounded-[6.03px] tw-border-[1.51px] tw-border-solid tw-border-[#24BD63] tw-h-[36px] tw-px-3 tw-flex tw-gap-2 tw-items-center tw-justify-center", { show: $setup.isShowProjectPostSuccessFloater }])
          }, [
            _createVNode(_component_CongratsIcon),
            _createVNode(_component_Text, null, {
              default: _withCtx(() => [
                _createTextVNode("Congratulations, Your Project is Live on iknowa")
              ]),
              _: 1
            })
          ], 2),
          ($setup.projectStatus == $setup.ProjectJobStatusEnum.QUOTE_ACCEPTED && !$setup.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createVNode(_component_v_icon, {
                  icon: "mdi-information-variant-circle",
                  color: "#0C0F4A"
                }),
                _hoisted_3
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            class: "main_project_preview !tw-mt-0 tw-relative",
            onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => ($setup.addComments && $setup.addComments(...args)), ["stop"])),
            ref: "canvas",
            id: "canvas_id"
          }, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_v_btn, {
                    "prepend-icon": "mdi-chevron-left",
                    variant: "plain",
                    onClick: $setup.onClickBackToSearchResults
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Back to Search results ")
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ])
              ])
            ])
          ], 512),
          (
        $setup.disputeProject &&
        !($setup.disputeProject?.disputeType === $setup.DisputeTypeEnums.CLOSED)
      )
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createVNode(_component_Text, {
                      variant: "h5",
                      textAlign: "left"
                    }, {
                      default: _withCtx(() => [
                        ($setup.disputeProject?.disputeType === $setup.DisputeTypeEnums.RAISED)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode(" Early Reconciliation Process (ERP) ")
                            ], 64))
                          : (
                $setup.disputeProject?.disputeType === $setup.DisputeTypeEnums.UNDER_REVIEW
              )
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createTextVNode(" iknowa Review ")
                              ], 64))
                            : (
                $setup.disputeProject?.disputeType === $setup.DisputeTypeEnums.ADR_REVIEW
              )
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                  _createTextVNode(" iknowa ADR Review ")
                                ], 64))
                              : (
                $setup.disputeProject?.disputeType === $setup.DisputeTypeEnums.CLOSED
              )
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                    _createTextVNode(" Dispute Closed ")
                                  ], 64))
                                : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _createVNode(_component_InfoIcon, { class: "tw-min-w-[15px] tw-w-[15px] tw-h-[15px]" }),
                      _createVNode(_component_Text, {
                        variant: "h6",
                        textWeight: "600",
                        textAlign: "left",
                        lineHeight: "18px"
                      }, {
                        default: _withCtx(() => [
                          ($setup.disputeProject?.disputeType === $setup.DisputeTypeEnums.RAISED)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createTextVNode(" Your project has entered into the early reconciliation phase. At this point, we encourage you to try and resolve the dispute independently. If no agreement is reached, the case will proceed to iknowa for review. ")
                              ], 64))
                            : (
                  $setup.disputeProject?.disputeType === $setup.DisputeTypeEnums.UNDER_REVIEW
                )
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _createTextVNode(" Your project is under review. The dispute is currently being evaluated. Please await further instructions or resolution from iknowa. ")
                                ], 64))
                              : (
                  $setup.disputeProject?.disputeType === $setup.DisputeTypeEnums.ADR_REVIEW
                )
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                    _createTextVNode(" Your project is in the ADR review phase. We suggest working together to resolve the issue. If the case remains unresolved, it will be escalated for formal arbitration. ")
                                  ], 64))
                                : (
                  $setup.disputeProject?.disputeType === $setup.DisputeTypeEnums.CLOSED
                )
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                      _createTextVNode(" The dispute has been closed. No further actions are required at this point. ")
                                    ], 64))
                                  : _createCommentVNode("", true)
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_12, [
                      _createVNode(_component_Button, {
                        class: "!tw-w-auto",
                        variant: "secondary",
                        label: "View Evidence",
                        onClick: $setup.onViewEvidence,
                        isLoading: $setup.isRequestedChat,
                        isCapitalize: true
                      }, null, 8, ["onClick", "isLoading"]),
                      (
                $setup.disputeProject?.disputeType !== $setup.DisputeTypeEnums.UNDER_REVIEW &&
                $setup.disputeProject?.disputeType !== $setup.DisputeTypeEnums.ADR_REVIEW
              )
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createVNode(_component_Button, {
                              class: "!tw-w-auto",
                              variant: "secondary",
                              label: 
                  $setup.extensionRequested
                    ? 'View Request Extension'
                    : 'Request for Extension'
                ,
                              isCapitalize: true,
                              onClick: $setup.onOpenDSPRequestExtensionModal
                            }, null, 8, ["label", "onClick"]),
                            ($setup.disputeProject)
                              ? (_openBlock(), _createBlock(_component_Button, {
                                  key: 0,
                                  class: "!tw-w-auto",
                                  variant: "accent",
                                  label: "close dispute",
                                  onClick: $setup.onCloseDispute,
                                  isCapitalize: true
                                }, null, 8, ["onClick"]))
                              : _createCommentVNode("", true)
                          ], 64))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _createVNode(_component_Text, {
                      variant: "h5",
                      whiteSpace: "nowrap"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString($setup.disputeProjectErpDueDate), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", {
                    onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.onOpenDSPEvidenceGuidanceModal(false))),
                    class: "tw-bg-white tw-cursor-pointer tw-rounded-[8px] tw-px-3 tw-py-2 tw-box-border tw-flex tw-items-center tw-justify-center tw-gap-2"
                  }, [
                    _createVNode(_component_v_icon, {
                      icon: "mdi-information",
                      color: "rgba(130, 133, 163, 1)"
                    }),
                    _createVNode(_component_Text, {
                      class: "!tw-text-[11px]",
                      textWeight: "400",
                      textColor: "rgba(130, 133, 163, 1)"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Guidance For Evidence")
                      ]),
                      _: 1
                    })
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (!$setup.loading)
            ? (_openBlock(), _createElementBlock("div", {
                key: 2,
                class: "main_project_preview !tw-mt-0 tw-relative",
                onClick: _cache[17] || (_cache[17] = _withModifiers(
//@ts-ignore
(...args) => ($setup.addComments && $setup.addComments(...args)), ["stop"])),
                ref: "canvas",
                id: "canvas_id"
              }, [
                ($setup.isShowOverlay)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "overlay__wrapper",
                      style: _normalizeStyle($setup.overlayStyle)
                    }, null, 4))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, [
                      _createVNode(_component_v_btn, {
                        "prepend-icon": "mdi-chevron-left",
                        variant: "plain",
                        onClick: $setup.onClickBackToSearchResults
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Back to Search results ")
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ]),
                    ($setup.ProjectData?.type === $setup.ProjectTypesEnum.EMERGENCY)
                      ? (_openBlock(), _createBlock(_component_EmergencyChip, { key: 0 }))
                      : _createCommentVNode("", true),
                    ($setup.ProjectData?.type === $setup.ProjectTypesEnum.STANDARD)
                      ? (_openBlock(), _createBlock(_component_StandardChip, { key: 1 }))
                      : _createCommentVNode("", true),
                    ($setup.ProjectData?.type === $setup.ProjectTypesEnum.ROUTINE)
                      ? (_openBlock(), _createBlock(_component_RoutineChip, { key: 2 }))
                      : _createCommentVNode("", true)
                  ]),
                  (
            $setup.ProjectData?.projectJobStatus?.id !== $setup.ProjectJobStatusEnum.COMPLETED
          )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                        _hoisted_19,
                        _createElementVNode("div", _hoisted_20, [
                          ($setup.ProjectData?.invitedMembersAndRoles?.length)
                            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList($setup.ProjectData?.invitedMembersAndRoles, (member, index) => {
                                return (_openBlock(), _createBlock(_component_v_list, { key: index }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_list_item, {
                                      "prepend-avatar": member?.prependAvatar,
                                      subtitle: member?.role,
                                      title: member?.email
                                    }, null, 8, ["prepend-avatar", "subtitle", "title"])
                                  ]),
                                  _: 2
                                }, 1024))
                              }), 128))
                            : _createCommentVNode("", true),
                          _createVNode(_component_v_btn, {
                            class: "button button-purple-border",
                            onClick: $setup.onClickInviteTeamButton
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" invite team member to project ")
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ]),
                        _createElementVNode("div", _hoisted_21, [
                          (
                ($setup.ProjectData?.type === $setup.ProjectTypesEnum.VIDEO_CONSULTATION &&
                  $setup.isShowVideoButton($setup.ProjectData?.projectJobStatus?.id)) ||
                $setup.ProjectData?.projectJobStatus?.id ===
                  $setup.ProjectJobStatusEnum.DRAFT_PROJECT
              )
                            ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                (
                  $setup.ProjectData?.type === $setup.ProjectTypesEnum.VIDEO_CONSULTATION &&
                  $setup.isShowVideoButton($setup.ProjectData?.projectJobStatus?.id)
                )
                                  ? (_openBlock(), _createBlock(_component_v_btn, {
                                      key: 0,
                                      onClick: $setup.redirectVideoConsultation,
                                      class: "button mt-2",
                                      color: "#7467B7"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(" Video Consultation ")
                                      ]),
                                      _: 1
                                    }, 8, ["onClick"]))
                                  : _createCommentVNode("", true),
                                (
                  $setup.ProjectData?.projectJobStatus?.id ===
                  $setup.ProjectJobStatusEnum.DRAFT_PROJECT
                )
                                  ? (_openBlock(), _createBlock(_component_v_btn, {
                                      key: 1,
                                      class: "button button-orange",
                                      onClick: $setup.onClickSiteVisit,
                                      loading: $setup.isShowLoaderOnSaveButton
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(" post live project ")
                                      ]),
                                      _: 1
                                    }, 8, ["onClick", "loading"]))
                                  : _createCommentVNode("", true),
                                (
                  $setup.ProjectData?.projectJobStatus?.id ===
                  $setup.ProjectJobStatusEnum.DRAFT_PROJECT
                )
                                  ? (_openBlock(), _createBlock(_component_v_btn, {
                                      key: 2,
                                      class: "save-btn",
                                      variant: "text",
                                      onClick: $setup.onClickSaveDraftProject,
                                      loading: $setup.isShowLoaderOnSaveButton
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(" save project to draft ")
                                      ]),
                                      _: 1
                                    }, 8, ["onClick", "loading"]))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true),
                          (
                [
                  $setup.ProjectJobStatusEnum.DRAFT_PROJECT,
                  $setup.ProjectJobStatusEnum.AWAITING_QUOTES,
                  $setup.ProjectJobStatusEnum.QUOTES_RECEIVED,
                  $setup.ProjectJobStatusEnum.CANCELLED,
                ].includes($setup.ProjectData?.projectJobStatus?.id)
              )
                            ? (_openBlock(), _createBlock(_component_v_btn, {
                                key: 1,
                                class: "delete-btn",
                                variant: "text",
                                onClick: $setup.onClickDeleteDraftProject
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(" Delete Project ")
                                ]),
                                _: 1
                              }, 8, ["onClick"]))
                            : _createCommentVNode("", true)
                        ]),
                        (
              $setup.projectDetails.projectJobStatus?.id ==
              $setup.ProjectJobStatusEnum.IN_PROGRESS
            )
                          ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                              (!$setup.disputeProject)
                                ? (_openBlock(), _createBlock(_component_Button, {
                                    key: 0,
                                    onClick: $setup.onCreateDisputeProject,
                                    label: "DISPUTE PROJECT",
                                    variant: "accent"
                                  }, null, 8, ["onClick"]))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_24, [
                    _hoisted_25,
                    _createElementVNode("div", _hoisted_26, [
                      _createElementVNode("div", _hoisted_27, [
                        _hoisted_28,
                        _createElementVNode("div", _hoisted_29, _toDisplayString($setup.projectDetails?.type), 1)
                      ]),
                      ($setup.projectDetails?.type !== $setup.ProjectTypesEnum.EMERGENCY)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                            (
                  [
                    $setup.ProjectTypesEnum.STANDARD,
                    $setup.ProjectTypesEnum.ROUTINE,
                    $setup.ProjectTypesEnum.VIDEO_CONSULTATION,
                  ].includes($setup.projectDetails?.type)
                )
                              ? (_openBlock(), _createElementBlock("div", _hoisted_31, " Preferred Start "))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_32, _toDisplayString($setup.projectDetails?.projectSubType), 1)
                          ]))
                        : _createCommentVNode("", true),
                      ($setup.projectDetails?.type !== $setup.ProjectTypesEnum.EMERGENCY)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                            _hoisted_34,
                            _createElementVNode("div", _hoisted_35, _toDisplayString($setup.ProjectData?.siteVisitStatus ? "Enabled" : "Disabled"), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_36, [
                      ($setup.isShowProjectRatingButton)
                        ? (_openBlock(), _createBlock(_component_v_btn, {
                            key: 0,
                            class: "button rating-btn button-purple-border",
                            onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.toggleRatingModal(null)))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Rate your Experience")
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.projectOverviewStatus.default, (overview) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: overview.id,
                          class: _normalizeClass([{
                status_complete: overview.completed,
                'pointer-cursor': overview.statusCode == $setup.projectStatus,
              }, "proj_loop overview__detail__item"])
                        }, [
                          _createElementVNode("div", _hoisted_37, [
                            _createVNode(_component_v_icon, null, {
                              default: _withCtx(() => [
                                _createElementVNode("img", {
                                  src: 
                      overview.iconName
                        ? require(`@/core/svgs/${overview.iconName}.svg`)
                        : require('@/core/uni-assets/svgs/house.svg')
                    ,
                                  alt: ""
                                }, null, 8, _hoisted_38)
                              ]),
                              _: 2
                            }, 1024),
                            _hoisted_39
                          ]),
                          _createElementVNode("div", {
                            class: "overview__detail__text",
                            onClick: ($event: any) => ($setup.onClickRedirectToRelevantTab(overview))
                          }, [
                            _createElementVNode("h5", null, _toDisplayString(overview.label), 1),
                            _createElementVNode("p", null, _toDisplayString(overview.description), 1)
                          ], 8, _hoisted_40)
                        ], 2))
                      }), 128)),
                      (!$setup.showProjectOverviewDialog)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 1,
                            class: "bottom_icon",
                            onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.showProjectOverviewDialog = true))
                          }, [
                            _createVNode(_component_v_icon, { icon: "\n               mdi-chevron-down\n              " })
                          ]))
                        : _createCommentVNode("", true),
                      _createVNode(_component_v_expand_transition, null, {
                        default: _withCtx(() => [
                          _withDirectives(_createElementVNode("div", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.projectOverviewStatus.expanded, (overview) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: overview.id,
                                class: _normalizeClass([{
                    status_complete: overview.completed,
                    'pointer-cursor': overview.statusCode == $setup.projectStatus,
                  }, "proj_loop overview__detail__item"])
                              }, [
                                _createElementVNode("div", _hoisted_41, [
                                  _createVNode(_component_v_icon, null, {
                                    default: _withCtx(() => [
                                      _createElementVNode("img", {
                                        src: 
                          overview.iconName
                            ? require(`@/core/svgs/${overview.iconName}.svg`)
                            : require('@/core/uni-assets/svgs/house.svg')
                        ,
                                        alt: ""
                                      }, null, 8, _hoisted_42)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _hoisted_43
                                ]),
                                _createElementVNode("div", {
                                  class: "overview__detail__text",
                                  onClick: ($event: any) => ($setup.onClickRedirectToRelevantTab(overview))
                                }, [
                                  _createElementVNode("h5", null, _toDisplayString(overview.label), 1),
                                  _createElementVNode("p", null, _toDisplayString(overview.description), 1)
                                ], 8, _hoisted_44)
                              ], 2))
                            }), 128))
                          ], 512), [
                            [_vShow, $setup.showProjectOverviewDialog]
                          ])
                        ]),
                        _: 1
                      }),
                      ($setup.showProjectOverviewDialog)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 2,
                            class: "bottom_icon",
                            onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.showProjectOverviewDialog = false))
                          }, [
                            _createVNode(_component_v_icon, { icon: "\n               mdi-chevron-up\n              " })
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_45, [
                  _createElementVNode("div", _hoisted_46, [
                    _createElementVNode("div", _hoisted_47, [
                      _createVNode(_component_v_btn, {
                        "prepend-icon": "mdi-chevron-left",
                        variant: "plain",
                        onClick: $setup.onClickBackToSearchResults
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Back to Search results ")
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ]),
                    ($setup.ProjectData?.type === $setup.ProjectTypesEnum.EMERGENCY)
                      ? (_openBlock(), _createBlock(_component_EmergencyChip, { key: 0 }))
                      : _createCommentVNode("", true),
                    ($setup.ProjectData?.type === $setup.ProjectTypesEnum.STANDARD)
                      ? (_openBlock(), _createBlock(_component_StandardChip, { key: 1 }))
                      : _createCommentVNode("", true),
                    ($setup.ProjectData?.type === $setup.ProjectTypesEnum.ROUTINE)
                      ? (_openBlock(), _createBlock(_component_RoutineChip, { key: 2 }))
                      : _createCommentVNode("", true),
                    ($setup.ProjectData?.type === $setup.ProjectTypesEnum.VIDEO_CONSULTATION)
                      ? (_openBlock(), _createBlock(_component_VideoConsultationChip, { key: 3 }))
                      : _createCommentVNode("", true)
                  ]),
                  (
            $setup.estimateDetails &&
            $setup.estimatePhasesMessage &&
            [
              $setup.ProjectJobStatusEnum.QUOTE_CONFIRMED,
              $setup.ProjectJobStatusEnum.IN_PROGRESS,
              $setup.ProjectJobStatusEnum.COMPLETED,
            ].includes($setup.ProjectData?.projectJobStatus?.id)
          )
                    ? (_openBlock(), _createBlock(_component_AlertCard, {
                        key: 0,
                        class: "tw-mt-8 md:!tw-mt-2 md:!tw-mb-4"
                      }, {
                        content: _withCtx(() => [
                          _createElementVNode("div", _hoisted_48, [
                            _createVNode(_component_Text, { variant: "h6" }, {
                              default: _withCtx(() => [
                                _createTextVNode("To Start Project")
                              ]),
                              _: 1
                            }),
                            _createElementVNode("div", { innerHTML: $setup.estimatePhasesMessage }, null, 8, _hoisted_49),
                            _createVNode(_component_Button, {
                              label: "Deposit Payment",
                              class: "!tw-w-[auto] !tw-mt-4",
                              onClick: $setup.redirectToEscrowAccount
                            }, null, 8, ["onClick"])
                          ])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_50, [
                    (!$setup.isEditProjectNoteSection)
                      ? (_openBlock(), _createBlock(_component_v_card, {
                          key: 0,
                          class: "project_info"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_51, [
                              _createElementVNode("div", _hoisted_52, [
                                _createElementVNode("div", _hoisted_53, [
                                  _createElementVNode("h5", {
                                    id: "project_name",
                                    "data-comment-element": "true",
                                    class: _normalizeClass({
                        comment_hover:
                          $setup.isShowDashboard.type === 'comment' &&
                          $setup.isAlreadyCommented('project_name'),
                      })
                                  }, _toDisplayString($setup.ProjectData?.name), 3),
                                  _createElementVNode("div", _hoisted_54, [
                                    ($setup.getPropertyCategory?.isCommercial)
                                      ? (_openBlock(), _createElementBlock("div", {
                                          key: 0,
                                          class: _normalizeClass(["raised", {
                          comment_hover:
                            $setup.isShowDashboard.type === 'comment' &&
                            $setup.isAlreadyCommented(
                              'project_review_item_icon_commercial'
                            ),
                        }]),
                                          "data-comment-element": "true",
                                          id: "project_review_item_icon_commercial"
                                        }, [
                                          _createVNode(_component_CommercialChip)
                                        ], 2))
                                      : _createCommentVNode("", true),
                                    ($setup.getPropertyCategory?.isResidential)
                                      ? (_openBlock(), _createElementBlock("div", {
                                          key: 1,
                                          class: _normalizeClass(["raised", {
                          comment_hover:
                            $setup.isShowDashboard.type === 'comment' &&
                            $setup.isAlreadyCommented(
                              'project_review_item_icon_residential'
                            ),
                        }]),
                                          "data-comment-element": "true",
                                          id: "project_review_item_icon_residential"
                                        }, [
                                          _createVNode(_component_ResidentialChip)
                                        ], 2))
                                      : _createCommentVNode("", true),
                                    _createElementVNode("div", {
                                      class: _normalizeClass(["project_id", {
                          comment_hover:
                            $setup.isShowDashboard.type === 'comment' &&
                            $setup.isAlreadyCommented('project_id_container'),
                        }]),
                                      id: "project_id_container",
                                      "data-comment-element": "true"
                                    }, [
                                      _hoisted_55,
                                      _createElementVNode("span", _hoisted_56, _toDisplayString($setup.ProjectData?.refId), 1)
                                    ], 2)
                                  ])
                                ]),
                                (
                      $setup.projectDetails?.projectJobStatus?.id ===
                        $setup.ProjectJobStatusEnum.DRAFT_PROJECT ||
                      $setup.projectDetails?.projectJobStatus?.id ===
                        $setup.ProjectJobStatusEnum.AWAITING_QUOTES
                    )
                                  ? (_openBlock(), _createBlock(_component_v_icon, {
                                      key: 0,
                                      class: "custom_edit",
                                      icon: "mdi-pencil",
                                      onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => ($setup.updateProjectNameNote($setup.ProjectData)), ["stop"]))
                                    }))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("div", _hoisted_57, [
                                _createElementVNode("h6", {
                                  id: "project_notes_title",
                                  "data-comment-element": "true",
                                  class: _normalizeClass({
                      comment_hover:
                        $setup.isShowDashboard.type === 'comment' &&
                        $setup.isAlreadyCommented('project_notes_title'),
                    })
                                }, " Project Notes ", 2),
                                _createElementVNode("p", {
                                  innerHTML: $setup.ProjectData?.description,
                                  id: "project_html_description",
                                  "data-comment-element": "true",
                                  class: _normalizeClass({
                      comment_hover:
                        $setup.isShowDashboard.type === 'comment' &&
                        $setup.isAlreadyCommented('project_html_description'),
                    })
                                }, null, 10, _hoisted_58)
                              ])
                            ])
                          ]),
                          _: 1
                        }))
                      : (_openBlock(), _createBlock(_component_v_card, {
                          key: 1,
                          class: "edit_project_info"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_59, [
                              _hoisted_60,
                              _createVNode(_component_v_text_field, {
                                disabled: 
                    $setup.projectDetails?.projectFrom === $setup.ProjectFrom.RECOMMENDATION
                  ,
                                density: "compact",
                                placeholder: "enter title",
                                modelValue: $setup.projectTitle,
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.projectTitle) = $event)),
                                variant: "outlined"
                              }, null, 8, ["disabled", "modelValue"])
                            ]),
                            _createElementVNode("div", _hoisted_61, [
                              _hoisted_62,
                              _createElementVNode("div", _hoisted_63, [
                                _createVNode(_component_quill_editor, {
                                  value: $setup.state.content,
                                  "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => (($setup.state.content) = $event)),
                                  options: $setup.state.editorOption,
                                  disabled: $setup.state.disabled,
                                  class: "editor_ql"
                                }, null, 8, ["value", "options", "disabled"])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_64, [
                              _createVNode(_component_v_btn, {
                                class: "button button-white",
                                onClick: $setup.onCancelProjectNotes,
                                variant: "outlined"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(" cancel ")
                                ]),
                                _: 1
                              }, 8, ["onClick"]),
                              _createVNode(_component_v_btn, {
                                class: "button button-orange",
                                onClick: $setup.onClickSaveProjectNotes,
                                loading: $setup.isLoadingProjectNotes,
                                "prepend-icon": "mdi-content-save"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(" save ")
                                ]),
                                _: 1
                              }, 8, ["onClick", "loading"])
                            ])
                          ]),
                          _: 1
                        }))
                  ]),
                  _createElementVNode("div", _hoisted_65, [
                    _createVNode(_component_v_expansion_panels, {
                      modelValue: $setup.tradeServicesPanel,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (($setup.tradeServicesPanel) = $event))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_expansion_panel, { class: "collapsible-component !tw-bg-transparent" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_expansion_panel_title, { class: "!tw-py-0 !tw-px-[20px]" }, {
                              actions: _withCtx(({ expanded }) => [
                                _createElementVNode("div", _hoisted_67, [
                                  (!expanded)
                                    ? (_openBlock(), _createBlock(_component_v_icon, {
                                        key: 0,
                                        icon: "mdi-chevron-right",
                                        class: "!tw-text-[14px]"
                                      }))
                                    : (_openBlock(), _createBlock(_component_v_icon, {
                                        key: 1,
                                        icon: "mdi-chevron-down",
                                        class: "!tw-text-[14px]"
                                      }))
                                ])
                              ]),
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_66, [
                                  _createVNode(_component_Text, {
                                    variant: "h5",
                                    class: "rmd:!tw-text-[22px]",
                                    textAlign: "left"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("Services")
                                    ]),
                                    _: 1
                                  }),
                                  (
                      !$setup.isEditSpecialismSection &&
                      ($setup.projectDetails?.projectJobStatus?.id ===
                        $setup.ProjectJobStatusEnum.DRAFT_PROJECT ||
                        $setup.projectDetails?.projectJobStatus?.id ===
                          $setup.ProjectJobStatusEnum.AWAITING_QUOTES)
                    )
                                    ? (_openBlock(), _createBlock(_component_BlueCircularPencilIcon, {
                                        key: 0,
                                        onClick: _cache[8] || (_cache[8] = _withModifiers(($event: any) => ($setup.updateSpecialismSection()), ["stop"]))
                                      }))
                                    : _createCommentVNode("", true)
                                ])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_expansion_panel_text, { class: "tw-py-0 tw-px-[20px] tw-m-0" }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_68, [
                                  (!$setup.ProjectData?.subCategories?.length)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_69, " No Services "))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("div", _hoisted_70, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.ProjectData?.subCategories, (subCategory) => {
                                      return (_openBlock(), _createElementBlock("div", {
                                        class: "specialism-card-list__item",
                                        key: subCategory.id
                                      }, [
                                        ($setup.isEditSpecialismSection)
                                          ? (_openBlock(), _createBlock(_component_v_btn, {
                                              key: 0,
                                              variant: "text",
                                              "aria-label": "Delete",
                                              class: "specialism-card-list__item-delete",
                                              "prepend-icon": "mdi-delete",
                                              onClick: ($event: any) => ($setup.onClickDeleteCategoryButton(subCategory?.id))
                                            }, null, 8, ["onClick"]))
                                          : _createCommentVNode("", true),
                                        _createElementVNode("div", _hoisted_71, [
                                          _createElementVNode("div", {
                                            class: _normalizeClass(["specialism-card-list__item-author-header", 
                            $setup.specialismCategoryClass(subCategory?.generatedBy)
                          ])
                                          }, [
                                            _createElementVNode("div", _hoisted_72, [
                                              (
                                $setup.specialismCategoryClass(
                                  subCategory?.generatedBy
                                ) === 'krystal'
                              )
                                                ? (_openBlock(), _createElementBlock("img", {
                                                    key: 0,
                                                    src: require('@/assets/icons/krystal.svg'),
                                                    alt: "krystalimg"
                                                  }, null, 8, _hoisted_73))
                                                : _createCommentVNode("", true),
                                              (
                                $setup.specialismCategoryClass(
                                  subCategory?.generatedBy
                                ) === 'property'
                              )
                                                ? (_openBlock(), _createElementBlock("img", {
                                                    key: 1,
                                                    src: require('@/assets/icons/house.svg'),
                                                    alt: "houseimage"
                                                  }, null, 8, _hoisted_74))
                                                : _createCommentVNode("", true)
                                            ]),
                                            _createElementVNode("h6", null, _toDisplayString(subCategory?.generatedBy), 1),
                                            _createVNode(_component_v_icon, { icon: "mdi-information-variant-circle-outline" })
                                          ], 2),
                                          _createElementVNode("div", _hoisted_75, [
                                            _createElementVNode("div", _hoisted_76, [
                                              (subCategory?.category?.iconName)
                                                ? (_openBlock(), _createElementBlock("img", {
                                                    key: 0,
                                                    src: 
                                require('@/assets/category-icons/' +
                                  subCategory?.category?.iconName +
                                  '.svg')
                              ,
                                                    alt: "Image"
                                                  }, null, 8, _hoisted_77))
                                                : _createCommentVNode("", true)
                                            ]),
                                            _createElementVNode("div", _hoisted_78, [
                                              _createElementVNode("h5", null, _toDisplayString(subCategory?.label), 1),
                                              _createElementVNode("p", null, _toDisplayString(subCategory?.category?.poLabel), 1)
                                            ])
                                          ])
                                        ])
                                      ]))
                                    }), 128))
                                  ])
                                ]),
                                ($setup.isEditSpecialismSection)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_79, [
                                      _createVNode(_component_v_btn, {
                                        class: "button button-purple-border",
                                        variant: "text",
                                        onClick: $setup.onClickAddMoreSpecialism
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(" Add more Services ")
                                        ]),
                                        _: 1
                                      }, 8, ["onClick"]),
                                      _createElementVNode("div", _hoisted_80, [
                                        _createVNode(_component_v_btn, {
                                          class: "button button-white",
                                          onClick: $setup.onClickCancelSpecialismButton,
                                          variant: "outlined"
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(" cancel ")
                                          ]),
                                          _: 1
                                        }, 8, ["onClick"]),
                                        _createVNode(_component_v_btn, {
                                          class: "button button-orange",
                                          loading: $setup.isLoadingProjectData,
                                          onClick: $setup.onClickSaveSpecialismButton
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(" save ")
                                          ]),
                                          _: 1
                                        }, 8, ["loading", "onClick"])
                                      ])
                                    ]))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_81, [
                    _createElementVNode("div", _hoisted_82, [
                      _createElementVNode("div", _hoisted_83, [
                        _createElementVNode("h4", {
                          id: "project_properties_title",
                          "data-comment-element": "true",
                          class: _normalizeClass({
                  comment_hover:
                    $setup.isShowDashboard.type === 'comment' &&
                    $setup.isAlreadyCommented('project_properties_title'),
                })
                        }, [
                          _createTextVNode(" Properties "),
                          _createElementVNode("span", _hoisted_84, _toDisplayString($setup.ProjectData?.projectProperties?.length || 0), 1)
                        ], 2)
                      ]),
                      _createVNode(_component_v_btn, {
                        onClick: $setup.togglePropertyMapView,
                        class: "map__button"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_85,
                          _hoisted_86
                        ]),
                        _: 1
                      }, 8, ["onClick"]),
                      (
                !$setup.isEditPropertiesSection &&
                ($setup.projectDetails?.projectJobStatus?.id ===
                  $setup.ProjectJobStatusEnum.DRAFT_PROJECT ||
                  $setup.projectDetails?.projectJobStatus?.id ===
                    $setup.ProjectJobStatusEnum.AWAITING_QUOTES)
              )
                        ? (_openBlock(), _createBlock(_component_v_icon, {
                            key: 0,
                            class: "custom_edit",
                            icon: "mdi-pencil",
                            onClick: _cache[10] || (_cache[10] = _withModifiers(($event: any) => ($setup.updatePropertiesSection()), ["stop"]))
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_87, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["properties_wrapper__left no-scrollbar", { 'tw-pt-3': $setup.isEditPropertiesSection }])
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.ProjectData?.projectProperties, (property, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "properties_wrapper__info",
                            key: property?.id
                          }, [
                            (
                    $setup.isEditPropertiesSection &&
                    $setup.ProjectData?.projectProperties.length >= 2
                  )
                              ? (_openBlock(), _createBlock(_component_v_icon, {
                                  key: 0,
                                  class: "delete__icon",
                                  icon: "mdi-delete",
                                  onClick: _withModifiers(($event: any) => ($setup.onClickRemoveProperty(property)), ["stop"])
                                }, null, 8, ["onClick"]))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_88, [
                              _createElementVNode("div", {
                                class: _normalizeClass(["prop_name", {
                      comment_hover:
                        $setup.isShowDashboard.type === 'comment' &&
                        $setup.isAlreadyCommented(
                          `project_property_prop_name_${property?.id}`
                        ),
                    }]),
                                id: `project_property_prop_name_${property?.id}`,
                                "data-comment-element": "true"
                              }, [
                                _createElementVNode("p", _hoisted_90, _toDisplayString(index + 1), 1),
                                _createElementVNode("h6", _hoisted_91, _toDisplayString(property?.property?.address), 1)
                              ], 10, _hoisted_89),
                              _createElementVNode("div", _hoisted_92, [
                                _createElementVNode("div", {
                                  class: _normalizeClass(["location", {
                        comment_hover:
                          $setup.isShowDashboard.type === 'comment' &&
                          $setup.isAlreadyCommented(
                            `project_property_prop_location_${property?.id}`
                          ),
                      }]),
                                  id: `project_property_prop_location_${property?.id}`,
                                  "data-comment-element": "true"
                                }, [
                                  _createVNode(_component_v_icon, {
                                    icon: "mdi mdi-map-marker",
                                    class: "pointer_events_none"
                                  }),
                                  _createTextVNode(" " + _toDisplayString(property?.property?.postcode), 1)
                                ], 10, _hoisted_93),
                                _createElementVNode("div", {
                                  class: _normalizeClass(["property_type", {
                        comment_hover:
                          $setup.isShowDashboard.type === 'comment' &&
                          $setup.isAlreadyCommented(
                            `project_property_prop_main_type_${property?.id}`
                          ),
                      }]),
                                  id: `project_property_prop_main_type_${property?.id}`,
                                  "data-comment-element": "true"
                                }, [
                                  (
                          property?.property?.propertyCategory ===
                          $setup.PropertyCategoryEnum.RESIDENTIAL
                        )
                                    ? (_openBlock(), _createBlock(_component_ResidentialChip, { key: 0 }))
                                    : _createCommentVNode("", true),
                                  (
                          property?.property?.propertyCategory ===
                          $setup.PropertyCategoryEnum.COMMERCIAL
                        )
                                    ? (_openBlock(), _createBlock(_component_CommercialChip, { key: 1 }))
                                    : _createCommentVNode("", true)
                                ], 10, _hoisted_94)
                              ])
                            ])
                          ]))
                        }), 128))
                      ], 2)
                    ]),
                    ($setup.isEditPropertiesSection)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_95, [
                          _createVNode(_component_v_btn, {
                            class: "button button-purple-border",
                            onClick: $setup.onClickTogglePropertyListModal,
                            variant: "text"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Add more Property ")
                            ]),
                            _: 1
                          }, 8, ["onClick"]),
                          _createElementVNode("div", _hoisted_96, [
                            _createVNode(_component_v_btn, {
                              class: "button button-white",
                              loading: $setup.isLoadingOnCancel,
                              onClick: $setup.onClickCancelButton,
                              variant: "outlined"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" cancel ")
                              ]),
                              _: 1
                            }, 8, ["loading", "onClick"]),
                            _createVNode(_component_v_btn, {
                              class: "button button-orange",
                              loading: $setup.isLoadingProjectData,
                              onClick: $setup.onClickSaveButton
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" save ")
                              ]),
                              _: 1
                            }, 8, ["loading", "onClick"])
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", {
                    class: _normalizeClass(["documents_attachment", { 'is-empty': !$setup.projectAttachments.length }])
                  }, [
                    _createElementVNode("div", _hoisted_97, [
                      _createElementVNode("h3", {
                        id: "project_documents_attachment_name",
                        class: _normalizeClass({
                comment_hover:
                  $setup.isShowDashboard.type === 'comment' &&
                  $setup.isAlreadyCommented('project_documents_attachment_name'),
              }),
                        "data-comment-element": "true"
                      }, " Documents / Attachments ", 2),
                      ($setup.projectAttachments.length)
                        ? (_openBlock(), _createBlock(_component_v_select, {
                            key: 0,
                            modelValue: $setup.propertyId,
                            "onUpdate:modelValue": [
                              _cache[11] || (_cache[11] = ($event: any) => (($setup.propertyId) = $event)),
                              $setup.changePropertyId
                            ],
                            label: "Select property",
                            items: $setup.projectAttachments,
                            "item-title": "address",
                            "item-value": "propertyId",
                            multiple: "",
                            variant: "outlined",
                            density: "compact",
                            class: "select_prop_dropdown",
                            "menu-props": { contentClass: 'custom__text__selector' }
                          }, null, 8, ["modelValue", "items", "onUpdate:modelValue"]))
                        : _createCommentVNode("", true)
                    ]),
                    (!$setup.loadingSelectProperty)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_98, [
                          _createVNode(_component_v_expansion_panels, {
                            modelValue: $setup.panel,
                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (($setup.panel) = $event)),
                            multiple: "",
                            class: "accordion__wrapper"
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.projectAttachments, (property, index) => {
                                return (_openBlock(), _createBlock(_component_v_expansion_panel, { key: index }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_expansion_panel_title, null, {
                                      actions: _withCtx(({ expanded }) => [
                                        (
                        expanded &&
                        !$setup.isEditAttachmentsSection &&
                        ($setup.projectDetails?.projectJobStatus?.id ===
                          $setup.ProjectJobStatusEnum.DRAFT_PROJECT ||
                          $setup.projectDetails?.projectJobStatus?.id ===
                            $setup.ProjectJobStatusEnum.AWAITING_QUOTES)
                      )
                                          ? (_openBlock(), _createBlock(_component_v_icon, {
                                              key: 0,
                                              class: "custom_edit",
                                              icon: "mdi-pencil",
                                              onClick: ($event: any) => ($setup.updateAttachmentsSection(index))
                                            }, null, 8, ["onClick"]))
                                          : (_openBlock(), _createBlock(_component_v_icon, {
                                              key: 1,
                                              icon: "mdi-chevron-down",
                                              class: "bottom__chevron"
                                            }))
                                      ]),
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_icon, { class: "house__icon" }, {
                                          default: _withCtx(() => [
                                            _hoisted_99
                                          ]),
                                          _: 1
                                        }),
                                        _createElementVNode("h6", {
                                          id: `project_property_attachments_doc_label_${property.propertyId}`,
                                          "data-comment-element": "true",
                                          class: _normalizeClass({
                      comment_hover:
                        $setup.isShowDashboard.type === 'comment' &&
                        $setup.isAlreadyCommented(
                          `project_property_attachments_doc_label_${property.propertyId}`
                        ),
                    })
                                        }, _toDisplayString(property?.address), 11, _hoisted_100)
                                      ]),
                                      _: 2
                                    }, 1024),
                                    ($setup.isShowGroupCard(index))
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_101, [
                                          _createElementVNode("div", _hoisted_102, [
                                            _createVNode(_component_v_expansion_panel_text, null, {
                                              default: _withCtx(() => [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.getFilterCategory(
                          property.categories
                        ), (category) => {
                                                  return (_openBlock(), _createElementBlock("div", {
                                                    class: "accordion_inner_title",
                                                    key: category.id
                                                  }, [
                                                    _createElementVNode("h3", {
                                                      id: `attachments_item_categories_name_${property.propertyId}_${category.id}`,
                                                      class: _normalizeClass({
                            comment_hover:
                              $setup.isShowDashboard.type === 'comment' &&
                              $setup.isAlreadyCommented(
                                `attachments_item_categories_name_${property.propertyId}_${category.id}`
                              ),
                          }),
                                                      "data-comment-element": "true"
                                                    }, _toDisplayString(category?.name), 11, _hoisted_103),
                                                    _createElementVNode("div", {
                                                      class: _normalizeClass(["doc_main", {
                            comment_hover:
                              $setup.isShowDashboard.type === 'comment' &&
                              $setup.isAlreadyCommented(
                                `attachments_item_categories_content_${property.propertyId}_${category.id}`
                              ),
                          }]),
                                                      id: `attachments_item_categories_content_${property.propertyId}_${category.id}`,
                                                      "data-comment-element": "true"
                                                    }, [
                                                      _createElementVNode("div", _hoisted_105, [
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(category.attachments, (attachment) => {
                                                          return (_openBlock(), _createElementBlock("div", {
                                                            class: "doc_main__list__item",
                                                            key: attachment.id
                                                          }, [
                                                            _createElementVNode("div", {
                                                              class: "property__img__name",
                                                              onClick: _withModifiers(($event: any) => (
                                  $setup.onClickOpenNewTab(attachment.attachmentUrl)
                                ), ["stop"])
                                                            }, [
                                                              _hoisted_107,
                                                              _createElementVNode("span", null, _toDisplayString(attachment?.originalName), 1)
                                                            ], 8, _hoisted_106),
                                                            ($setup.isEditAttachmentsSection)
                                                              ? (_openBlock(), _createElementBlock("div", {
                                                                  key: 0,
                                                                  onClick: ($event: any) => (
                                  $setup.onClickRemoveAttachment(
                                    attachment,
                                    property,
                                    category?.name,
                                    index,
                                    category?.id
                                  )
                                )
                                                                }, [
                                                                  _createVNode(_component_v_icon, {
                                                                    icon: "mdi-close",
                                                                    class: "pointer_events_none"
                                                                  })
                                                                ], 8, _hoisted_108))
                                                              : _createCommentVNode("", true)
                                                          ]))
                                                        }), 128))
                                                      ])
                                                    ], 10, _hoisted_104)
                                                  ]))
                                                }), 128)),
                                                (
                          $setup.getNoCategoryAttachmentList(property?.categories)
                            ?.length
                        )
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_109, [
                                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.getNoCategoryAttachmentList(
                            property.categories
                          ), (attachment) => {
                                                        return (_openBlock(), _createElementBlock("div", {
                                                          key: attachment.id,
                                                          class: "property__item__images"
                                                        }, [
                                                          _createElementVNode("img", {
                                                            src: attachment?.attachmentUrl,
                                                            onClick: ($event: any) => (
                              $setup.openCarousel(attachment.id, property.categories)
                            )
                                                          }, null, 8, _hoisted_110)
                                                        ]))
                                                      }), 128))
                                                    ]))
                                                  : _createCommentVNode("", true),
                                                ($setup.isEditAttachmentsSection)
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_111, [
                                                      _createVNode(_component_v_btn, {
                                                        class: "button button-purple-border",
                                                        onClick: $setup.onClickToggleAttachmentModal
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createTextVNode(" Upload More ")
                                                        ]),
                                                        _: 1
                                                      }, 8, ["onClick"]),
                                                      _createElementVNode("div", _hoisted_112, [
                                                        _createVNode(_component_v_btn, {
                                                          class: "button button-white",
                                                          variant: "outlined",
                                                          loading: $setup.isLoadingOnAttachmentCancel,
                                                          onClick: $setup.onCancelAttachments
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createTextVNode(" cancel ")
                                                          ]),
                                                          _: 1
                                                        }, 8, ["loading", "onClick"]),
                                                        _createVNode(_component_v_btn, {
                                                          class: "button button-orange",
                                                          size: "large",
                                                          block: "",
                                                          loading: $setup.isLoadingRemoveAttachments,
                                                          onClick: $setup.onClickSaveButtonAttachments
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createTextVNode(" save ")
                                                          ]),
                                                          _: 1
                                                        }, 8, ["loading", "onClick"])
                                                      ])
                                                    ]))
                                                  : _createCommentVNode("", true)
                                              ]),
                                              _: 2
                                            }, 1024)
                                          ])
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 2
                                }, 1024))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_113, [
                          _createVNode(_component_Loader, { show: $setup.loadingSelectProperty }, null, 8, ["show"])
                        ])),
                    _createElementVNode("div", null, [
                      (
                !$setup.projectAttachments.length &&
                !$setup.isEditSpecialismSection &&
                ($setup.projectDetails?.projectJobStatus?.id ===
                  $setup.ProjectJobStatusEnum.DRAFT_PROJECT ||
                  $setup.projectDetails?.projectJobStatus?.id ===
                    $setup.ProjectJobStatusEnum.AWAITING_QUOTES)
              )
                        ? (_openBlock(), _createBlock(_component_v_btn, {
                            key: 0,
                            class: "button button-purple-border tw-mt-5",
                            onClick: $setup.onClickToggleAttachmentModal,
                            "aria-disabled": ""
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Upload Attachments ")
                            ]),
                            _: 1
                          }, 8, ["onClick"]))
                        : _createCommentVNode("", true)
                    ])
                  ], 2),
                  (
            ['jobDetails', 'projectDetails'].includes($props.type) &&
            $setup.isShowDashboard.type == 'comment'
          )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_114, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.projectComments, (val, index) => {
                          return (_openBlock(), _createBlock(_component_ToolTipComment, {
                            key: val.id,
                            index: index,
                            commentElement: val,
                            projectId: $setup.ProjectData.id,
                            activeComment: $setup.activeComment,
                            commentsLength: $setup.projectComments.length,
                            userImagesMap: $setup.userImagesMap,
                            onToggleActiveComment: $setup.toggleActiveComment,
                            onUpdateCommentRoomStatus: $setup.updateCommentRoomStatus,
                            onNextComment: $setup.nextComment
                          }, null, 8, ["index", "commentElement", "projectId", "activeComment", "commentsLength", "userImagesMap", "onToggleActiveComment", "onUpdateCommentRoomStatus", "onNextComment"]))
                        }), 128))
                      ], 512))
                    : _createCommentVNode("", true)
                ]),
                _createVNode(_component_commonDialog, {
                  modelValue: $setup.isShowPropertyListModal,
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (($setup.isShowPropertyListModal) = $event)),
                  isShowHeader: false,
                  isShowBackButton: false,
                  width: "1010px",
                  height: "auto",
                  "max-width": "100%",
                  persistent: "",
                  className: ['edit__propertyList__modal']
                }, {
                  body: _withCtx(() => [
                    _createVNode(_component_v_icon, {
                      class: "close__icon",
                      icon: "mdi-close",
                      onClick: $setup.onClickTogglePropertyListModal
                    }, null, 8, ["onClick"]),
                    _createElementVNode("div", _hoisted_115, [
                      _createElementVNode("h3", null, [
                        _createTextVNode(" Properties "),
                        _createElementVNode("span", _hoisted_116, _toDisplayString($setup.ProjectData?.projectProperties?.length), 1)
                      ]),
                      _hoisted_117,
                      _createElementVNode("span", _hoisted_118, _toDisplayString($setup.propertyEditModalAlert), 1)
                    ]),
                    _createElementVNode("div", _hoisted_119, [
                      _createElementVNode("div", _hoisted_120, [
                        _createElementVNode("div", _hoisted_121, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.propertiesList, (property, index) => {
                            return (_openBlock(), _createBlock(_component_v_card, {
                              class: _normalizeClass(["courses__card", { 'selected-card': $setup.isSelected(property?.id) }]),
                              onClick: ($event: any) => ($setup.toggleSelection(property?.id)),
                              key: index
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_122, [
                                  _createElementVNode("img", {
                                    class: "",
                                    cover: "",
                                    src: 
                        require('@/assets/images/solar-pv-installation-hero.jpg')
                      
                                  }, null, 8, _hoisted_123)
                                ]),
                                _createElementVNode("div", _hoisted_124, [
                                  _createElementVNode("div", _hoisted_125, [
                                    _createVNode(_component_v_icon, null, {
                                      default: _withCtx(() => [
                                        _hoisted_126
                                      ]),
                                      _: 1
                                    }),
                                    _createElementVNode("p", null, _toDisplayString($setup.getPropertyType(property)), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_127, [
                                    _createVNode(_component_v_icon, { icon: "mdi-map-marker" }),
                                    _createElementVNode("p", null, _toDisplayString(property?.postcode), 1)
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_128, [
                                  _createElementVNode("h5", _hoisted_129, _toDisplayString(property?.address), 1)
                                ])
                              ]),
                              _: 2
                            }, 1032, ["class", "onClick"]))
                          }), 128))
                        ]),
                        _createElementVNode("div", _hoisted_130, [
                          ($setup.isPaginationAvailable)
                            ? (_openBlock(), _createElementBlock("label", {
                                key: 0,
                                onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => ($setup.onLoadMore && $setup.onLoadMore(...args))),
                                class: "yellow-text"
                              }, [
                                _createTextVNode(" Load More Properties"),
                                _createVNode(_component_v_icon, { icon: "mdi-chevron-right" })
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_131, [
                        _createVNode(_component_Button, {
                          label: "CANCEL",
                          variant: "secondary",
                          class: "button",
                          onClick: $setup.onClickTogglePropertyListModal
                        }, null, 8, ["onClick"]),
                        _createVNode(_component_Button, {
                          label: "SAVE",
                          variant: "accent",
                          class: "button",
                          isLoading: $setup.isLoadingProjectData,
                          onClick: $setup.onClickPropertyModalSave
                        }, null, 8, ["isLoading", "onClick"])
                      ])
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_commonDialog, {
                  modelValue: $setup.isShowAttachmentModal,
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (($setup.isShowAttachmentModal) = $event)),
                  isShowHeader: false,
                  isShowBackButton: false,
                  width: "832px",
                  "max-width": "100%",
                  persistent: "",
                  className: ['property__upload__modal']
                }, {
                  body: _withCtx(() => [
                    _createVNode(_component_v_icon, {
                      icon: "mdi-close",
                      class: "close__icon",
                      onClick: $setup.onClickToggleAttachmentModal
                    }, null, 8, ["onClick"]),
                    _createElementVNode("div", _hoisted_132, [
                      _createElementVNode("div", _hoisted_133, [
                        _hoisted_134,
                        _createElementVNode("div", _hoisted_135, [
                          _createElementVNode("div", _hoisted_136, [
                            _createVNode(_component_v_file_input, {
                              class: _normalizeClass(["upload_file", { 'added-img': $setup.imageUrl }]),
                              label: "Upload",
                              "append-inner-icon": "mdi-image-plus",
                              accept: "image/png, image/jpeg, image/jpg",
                              variant: "solo-filled",
                              modelValue: $setup.selectedFile,
                              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (($setup.selectedFile) = $event)),
                              onChange: $setup.onFileChange,
                              "onClick:clear": $setup.clearImageUrl,
                              multiple: ""
                            }, null, 8, ["modelValue", "class", "onChange", "onClick:clear"]),
                            _createVNode(_component_v_img, {
                              class: "uploaded-img",
                              width: 200,
                              "aspect-ratio": "16/9",
                              cover: "",
                              src: $setup.imageUrl
                            }, null, 8, ["src"]),
                            _createVNode(_component_v_icon, { icon: "mdi mdi-file-image-box" }),
                            ($setup.errorMessage)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_137, _toDisplayString($setup.errorMessage), 1))
                              : _createCommentVNode("", true)
                          ]),
                          _hoisted_138
                        ])
                      ]),
                      _createVNode(_component_ProjectAttachmentListComponent, {
                        attachmentList: $setup.attachmentDataList,
                        onOnDelete: $setup.removeImageFromAttachments,
                        properties: $setup.userSelectedProperties,
                        isProjectDetailPage: true,
                        propertyRequiredError: $setup.propertyRequiredError
                      }, null, 8, ["attachmentList", "onOnDelete", "properties", "propertyRequiredError"])
                    ]),
                    _createElementVNode("div", _hoisted_139, [
                      _createVNode(_component_Button, {
                        label: "Cancel",
                        variant: "secondary",
                        class: "button",
                        onClick: $setup.onClickToggleAttachmentModal
                      }, null, 8, ["onClick"]),
                      _createVNode(_component_Button, {
                        label: "Save",
                        class: "!tw-w-auto button",
                        variant: "accent",
                        onClick: $setup.onClickSaveButtonAttachmentsModal,
                        isLoading: $setup.isLoadingUploadAttachments
                      }, null, 8, ["onClick", "isLoading"])
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                ($setup.activeAddComment && $setup.activeAddComment.length)
                  ? (_openBlock(), _createBlock(_component_AddCommentComponent, {
                      key: 1,
                      commentData: $setup.activeAddComment[0],
                      onOnComment: $setup.onComment
                    }, null, 8, ["commentData", "onOnComment"]))
                  : _createCommentVNode("", true),
                ($setup.iShowInviteTeamMemberModal)
                  ? (_openBlock(), _createBlock(_component_InviteTeamMember, {
                      key: 2,
                      onOnCloseModal: $setup.onCloseModal,
                      projectId: $setup.ProjectData?.id
                    }, null, 8, ["onOnCloseModal", "projectId"]))
                  : _createCommentVNode("", true),
                ($setup.isShowSpecialismModal)
                  ? (_openBlock(), _createBlock(_component_SpecialismMultiSelectModel, {
                      key: 3,
                      isHistorical: false,
                      projectId: $setup.ProjectData.id,
                      selectedSpecialism: $setup.ProjectData?.subCategories,
                      isLoading: $setup.isLoadingForSaveSpecialism,
                      onOnClickCloseTab: $setup.onClickCloseTab,
                      onOnClickSaveButtonClick: $setup.onClickSaveButtonClick
                    }, null, 8, ["projectId", "selectedSpecialism", "isLoading", "onOnClickCloseTab", "onOnClickSaveButtonClick"]))
                  : _createCommentVNode("", true)
              ], 512))
            : _createCommentVNode("", true)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_140, [
          _createVNode(_component_Loader, { show: $setup.loading }, null, 8, ["show"])
        ])),
    _createVNode(_component_v_dialog, {
      modelValue: $setup.isCarouselDialog,
      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (($setup.isCarouselDialog) = $event)),
      height: "auto",
      "max-width": "600",
      class: "project__carousal__modal",
      "show-arrows": false
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          actions: _withCtx(() => [
            _createVNode(_component_v_btn, {
              icon: "mdi-close",
              onClick: _cache[18] || (_cache[18] = ($event: any) => ($setup.isCarouselDialog = false)),
              class: "d-flex"
            }),
            _createVNode(_component_v_carousel, {
              "hide-delimiter-background": "",
              "show-arrows": $setup.carouselImageList?.length > 1,
              modelValue: $setup.currentIndex,
              "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (($setup.currentIndex) = $event))
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.carouselImageList, (attachment) => {
                  return (_openBlock(), _createBlock(_component_v_carousel_item, {
                    key: attachment.id
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_img, {
                        cover: "",
                        src: attachment?.attachmentUrl,
                        height: "100%",
                        width: "100%"
                      }, null, 8, ["src"])
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              _: 1
            }, 8, ["show-arrows", "modelValue"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    ($setup.isShowCommentSection)
      ? (_openBlock(), _createBlock(_component_ChatCommentsComponent, {
          key: 2,
          isShowDashboard: $setup.isShowDashboard,
          activeComment: $setup.activeComment,
          projectComments: $setup.projectComments,
          projectId: $setup.ProjectData?.id,
          userImagesMap: $setup.userImagesMap,
          onOpenMessageDashboard: $setup.openMessageDashboard,
          onToggleActiveComment: $setup.toggleActiveComment,
          onUpdateCommentRoomStatus: $setup.updateCommentRoomStatus
        }, null, 8, ["isShowDashboard", "activeComment", "projectComments", "projectId", "userImagesMap", "onOpenMessageDashboard", "onToggleActiveComment", "onUpdateCommentRoomStatus"]))
      : _createCommentVNode("", true),
    ($setup.isShowReviewModal && $setup.projectDetails?.id)
      ? (_openBlock(), _createBlock(_component_ProjectRateModal, {
          key: 3,
          type: $setup.ProjectRatingTypeEnum.PROPERTY_OWNER,
          ratingData: $setup.projectRatingData,
          onOnClose: $setup.toggleRatingModal,
          projectId: $setup.projectDetails?.id,
          reviewType: "project",
          projectName: $setup.ProjectData?.name
        }, null, 8, ["type", "ratingData", "onOnClose", "projectId", "projectName"]))
      : _createCommentVNode("", true),
    ($setup.isShowSiteVisitModal)
      ? (_openBlock(), _createBlock(_component_SiteVisitModel, {
          key: 4,
          onOnClickBack: $setup.onClickSiteVisit,
          onOnClickPostProject: $setup.onClickPostLiveProject,
          projectId: $setup.ProjectData?.id
        }, null, 8, ["onOnClickBack", "onOnClickPostProject", "projectId"]))
      : _createCommentVNode("", true),
    ($setup.isOpenConfirmDeleteProjectModal)
      ? (_openBlock(), _createBlock(_component_ConfirmDeleteProjectModal, {
          key: 5,
          onOnClose: $setup.onCloseConfirmDeleteProjectModal,
          projectDetail: $setup.ProjectData
        }, null, 8, ["onOnClose", "projectDetail"]))
      : _createCommentVNode("", true),
    ($setup.isShowSuccessSendReviewModal)
      ? (_openBlock(), _createBlock(_component_SuccessSendingReviewModal, {
          key: 6,
          onOnClose: $setup.onCloseSuccessSendReviewModal
        }, null, 8, ["onOnClose"]))
      : _createCommentVNode("", true),
    ($setup.isShowPropertyMapView && $setup.ProjectData?.projectProperties?.length)
      ? (_openBlock(), _createBlock(_component_PropertyWithMapModal, {
          key: 7,
          propertyList: $setup.ProjectData?.projectProperties,
          onClose: $setup.togglePropertyMapView
        }, null, 8, ["propertyList", "onClose"]))
      : _createCommentVNode("", true),
    ($setup.isOpenDspEvidenceModal)
      ? (_openBlock(), _createBlock(_component_DSPModal, {
          key: 8,
          project: $setup.projectDetails,
          onClose: $setup.toggleDspEvidenceModal,
          onSubmit: $setup.submitDisputeProject
        }, null, 8, ["project", "onClose", "onSubmit"]))
      : _createCommentVNode("", true),
    ($setup.isOpenDSPInformationModal)
      ? (_openBlock(), _createBlock(_component_DSPInformationModal, {
          key: 9,
          onClose: $setup.toggleDSPInformationModal,
          onShowDspOverviewModal: $setup.toggleDspProjectDetail
        }, null, 8, ["onClose", "onShowDspOverviewModal"]))
      : _createCommentVNode("", true),
    ($setup.isOpenDspOverviewModal)
      ? (_openBlock(), _createBlock(_component_DSPOverviewModal, {
          key: 10,
          onClose: $setup.toggleDspOverviewModal,
          onOnProceedContinue: $setup.toggleDSPInformationModal,
          onOnOpenGuidanceModal: $setup.onOpenDSPEvidenceGuidanceModal
        }, null, 8, ["onClose", "onOnProceedContinue", "onOnOpenGuidanceModal"]))
      : _createCommentVNode("", true),
    ($setup.isOpenDspProjectModal)
      ? (_openBlock(), _createBlock(_component_DSPProjectDetailModal, {
          key: 11,
          estimateData: $setup.estimateData,
          onClose: $setup.toggleDspProjectDetail,
          onContinue: $setup.continueDisputeProjectDetails
        }, null, 8, ["estimateData", "onClose", "onContinue"]))
      : _createCommentVNode("", true),
    ($setup.isOpenDisputeReasonModal)
      ? (_openBlock(), _createBlock(_component_DisputeReasonModal, {
          key: 12,
          onClose: $setup.toggleDisputeReasonModal,
          onSendSelectedReasons: $setup.handleSelectedReasons
        }, null, 8, ["onClose", "onSendSelectedReasons"]))
      : _createCommentVNode("", true),
    ($setup.isOpenDspEvidenceGuidanceModal)
      ? (_openBlock(), _createBlock(_component_DSPEvidenceGuidanceModal, {
          key: 13,
          onOnClose: $setup.onCloseDSPEvidenceGuidanceModal
        }, null, 8, ["onOnClose"]))
      : _createCommentVNode("", true),
    ($setup.isOpenRequestExtensionModal)
      ? (_openBlock(), _createBlock(_component_DSPRequestExtensionModal, {
          key: 14,
          disputeProject: $setup.disputeProject,
          extensionRequested: $setup.extensionRequested,
          onOnClose: $setup.onCloseDSPRequestExtensionModal,
          projectDetails: $setup.projectDetails
        }, null, 8, ["disputeProject", "extensionRequested", "onOnClose", "projectDetails"]))
      : _createCommentVNode("", true),
    ($setup.isShowViewEvidenceModal)
      ? (_openBlock(), _createBlock(_component_ViewEvidenceModal, {
          key: 15,
          projectData: $setup.ProjectData,
          onOnClose: $setup.onCloseViewEvidenceModal
        }, null, 8, ["projectData", "onOnClose"]))
      : _createCommentVNode("", true),
    ($setup.isPostLoadingModal)
      ? (_openBlock(), _createBlock(_component_PostProjectLoadingModal, {
          key: 16,
          switchingText: $setup.switchingText,
          projectPostProgressLoading: $setup.projectPostProgressLoading
        }, null, 8, ["switchingText", "projectPostProgressLoading"]))
      : _createCommentVNode("", true)
  ], 64))
}